import { ErrorBoundary } from '@sentry/react';
import { ReactNode, Suspense } from 'react';
import { NoTextLoader } from '../contentState/NoTextLoader';
import { DashboardContent, DashboardContentHeading } from './DashboardContent';

export const DashboardContentFallback = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary fallback={<DashboardContent entityId={null} dashboardWidgets={[]} />}>
    <Suspense
      fallback={
        <DashboardContentHeading>
          <NoTextLoader />
        </DashboardContentHeading>
      }
    >
      {children}
    </Suspense>
  </ErrorBoundary>
);
